import { UniObject } from '@uiwebkit/common';

export const UniSelectionClasses = {
  selection: 'uni-selection',
  background: 'uni-selection-background',
  outlined: 'uni-selection-outlined'
}

export function uniSelectionClass(active: boolean, outlined: boolean): UniObject<boolean> {
  return {
    [UniSelectionClasses.selection]: true,
    [UniSelectionClasses.background]: active && !outlined,
    [UniSelectionClasses.outlined]: active && outlined
  };
}
